export default {
  "redPacketRecord.title": "Red Packet Record",

  "redPacketRecord.column.no": "#NO",
  "redPacketRecord.column.userNo": "User No",
  "redPacketRecord.column.email": "Email",
  "redPacketRecord.column.title": "Title",
  "redPacketRecord.column.type": "Type",
  "redPacketRecord.column.amount": "Amount",
  "redPacketRecord.column.claimTime": "Claim Time",

  "redPacketRecord.column.createTime": "Create Time",
  "redPacketRecord.search.userNo": "User No",
  "redPacketRecord.search.eventId": "Event ID",
  "redPacketRecord.search.channel": "Channel",
  "redPacketRecord.search.eventType": "Event Type",
  "redPacketRecord.tooltip.copy.userNo": "Copy User No: {text}",
  "redPacketRecord.tooltip.copy.eventId": "Copy Event ID: {text}",
  "redPacketRecord.tooltip.showUserDetails": "Show User Details",
  "redPacketRecord.copy.success": "Copied to clipboard",
};